import { StatusBadge } from "@/components/ui/status-badge";

import { CaseStatus } from "../../../api/types";
import { CASE_STATUS_TONE } from "../../../components/case/caseStatusColors";

export { CASE_STATUS_TONE };

export const isCaseStatus = (value: unknown): value is CaseStatus =>
  typeof value === "string" &&
  Object.values(CaseStatus).includes(value as CaseStatus);

/** Read-only status pill used by the cases tables (CasesV2, client profile). */
export const CaseStatusPill = ({ status }: { status: CaseStatus | string }) => {
  const normalized = isCaseStatus(status) ? status : CaseStatus.IN_PROGRESS;
  return (
    <StatusBadge tone={CASE_STATUS_TONE[normalized]} dot>
      {status || "—"}
    </StatusBadge>
  );
};
